import { forwardRef, useMemo } from "react";
import { DisclosureArrow } from "../../disclosure";
import { Div, HtmlButton } from "../../html";
import { H3, Text } from "../../typography";
import { cssModule, mergeProps, omitProps, useSlots } from "../../shared";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "button";
export function InnerAccordionHeader(props) {
  const {
    active,
    children,
    disabled,
    focus,
    forwardedRef,
    hover,
    headingType: HeadingType = H3,
    headingProps,
    ...rest
  } = omitProps(props, ["header"]);
  const {
    counter,
    icon,
    text
  } = useSlots(children, useMemo(() => ({
    _: {
      defaultWrapper: Text
    },
    counter: {
      color: "inherit",
      pushed: true,
      size: "inherit",
      variant: "divider"
    },
    icon: {
      className: "o-ui-accordion-icon"
    },
    text: {
      className: "o-ui-accordion-title",
      size: "inherit"
    }
  }), []));
  return /*#__PURE__*/_jsx(HeadingType, { ...mergeProps(headingProps !== null && headingProps !== void 0 ? headingProps : {}, {
      className: "o-ui-accordion-header",
      size: "2xs"
    }),
    children: /*#__PURE__*/_jsxs(HtmlButton, { ...mergeProps(rest, {
        className: cssModule("o-ui-accordion-trigger", active && "active", focus && "focus", hover && "hover", icon && "has-icon"),
        disabled,
        ref: forwardedRef,
        type: "button"
      }),
      children: [/*#__PURE__*/_jsxs(Div, {
        className: "o-ui-accordion-trigger-content",
        children: [icon, text, counter]
      }), /*#__PURE__*/_jsx(DisclosureArrow, {
        className: "o-ui-accordion-arrow"
      })]
    })
  });
}
InnerAccordionHeader.defaultElement = DefaultElement;
export const AccordionHeader = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerAccordionHeader, { ...props,
  forwardedRef: ref
}));